import PopupModal, { PopupButton } from "./Modal";

export default function ConfirmationModal({
  open,
  progress,
  closeModal,
  submit,
  heading,
  message,
}) {
  return (
    <PopupModal
      open={open}
      heading={heading || "Confirmation"}
      message={message || "Are you sure you want to this plan?"}
    >
      <PopupButton onClick={closeModal}>Cancel</PopupButton>
      <PopupButton
        onClick={submit}
        style={{
          background: "#f13a3a",
          color: "#ffffff",
        }}
      >
        {progress ? "Please wait..." : "Confirm"}
      </PopupButton>
    </PopupModal>
  );
}
